import { Outlet } from 'react-router-dom';
import { DashboardProvider } from './hooks/useDashboard';
import Sidebar from './components/layout/Sidebar';
import Header  from './components/layout/Header';
import './styles/globals.css';

export default function App() {
  return (
    <DashboardProvider>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <Sidebar />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflowX: 'hidden' }}>
          <Header />
          <Outlet />
        </div>
      </div>
    </DashboardProvider>
  );
}
